.asw-rg{position:fixed;left:0;right:0;width:100%;height:80px;pointer-events:none;z-index:1000000;box-shadow:0 0 0 9999px #000c}
